import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/common/calender.png'
import _imports_1 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "historyContainer" }
const _hoisted_3 = { class: "dayImage2" }
const _hoisted_4 = {
  class: "dateText",
  style: {"font-size":"12px"}
}
const _hoisted_5 = {
  class: "dayTitle",
  style: {"font-size":"12px"}
}
const _hoisted_6 = { style: {"padding-left":"10px"} }
const _hoisted_7 = { class: "right-texts" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_9 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_10 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_11 = {
  key: 3,
  style: {"color":"#ff0000"}
}
const _hoisted_12 = {
  key: 2,
  class: "no_more"
}

import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { checkinRewardsHistory } from '@/api/activity';
import { formatCurrency } from '@/utils/commonFunction';
import NoData from '../../components/common/noData.vue';
import CustomHeader from '../../components/common/customHeader.vue';
const PAGE_SIZE = 20

export default /*@__PURE__*/_defineComponent({
  __name: 'checkingHistoryPopup',
  props: {
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    title: String,
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
},
  setup(__props, { expose: __expose }) {

const props = __props
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const historyList = ref<any[]>([])
const loadingRef = ref()
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const total = ref(0)
const open = () => {
    show.value = true
    getHistory()
}

const close = () => {
    show.value = false
    historyList.value = []
    total.value = 0
    pageNum.value = 1
}
const getHistory = () => {
    checkinRewardsHistory().then(res => {
        loadingRef.value.close()
        total.value = res.data.total
        historyList.value = [...historyList.value, ...res.data.rows]
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getNextPageRewardData = () => {
    if (total.value > pageSize.value) {
        loadingRef.value.open()
        getHistory()
        pageSize.value = pageSize.value + PAGE_SIZE
    }
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "right",
      style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomHeader, {
            text: _ctx.$t('common.history'),
            isPopupCloseBackIcon: true,
            onClosePopup: close
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_2, [
            (historyList.value?.length <= 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "cardcontainer",
                key: index
              }, [
                _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "6",
                      class: "dayColumn"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _cache[1] || (_cache[1] = _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)),
                          _createElementVNode("div", _hoisted_4, _toDisplayString(item?.rewardDate?.split(' ')[0]), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, {
                      span: "12",
                      class: "topRow",
                      style: {"margin":"10px 0"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.$t('activity.claimAmount')) + " : ", 1),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatCurrency)(item?.coin)), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, {
                      span: "6",
                      class: "dayColumn"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, [
                          (item?.status == 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                            : (item?.status == 1)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                              : (item?.status == 2)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                                : (item?.status == 3)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                                  : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            (total.value > pageNum.value * pageSize.value)
              ? (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "24",
                      class: "arrowDown"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "",
                          onClick: getNextPageRewardData
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (historyList.value?.length != 0 && total.value < pageNum.value * pageSize.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('message.noMore')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})